import { useState, useMemo } from "react";

// ── BRAND IMAGES (compressed) ─────────────────────────────────────────────

// ── COMPOUND DATABASE ─────────────────────────────────────────────────────
const COMPOUNDS = [
  // GH AXIS
  { id:"bpc157", name:"BPC-157", cat:"Healing & Recovery", route:"SC/IM", unit:"mcg",
    protocols:[
      { goal:"Injury Recovery", dose_per_kg:null, flat_dose:250, freq:"Twice daily", duration:"4–8 weeks", notes:"Inject near injury site if possible. Split AM/PM doses." },
      { goal:"Gut Healing", dose_per_kg:null, flat_dose:500, freq:"Once daily (oral or SC)", duration:"4–6 weeks", notes:"Oral route effective for GI conditions. SC for systemic." },
    ]},
  { id:"tb500", name:"TB-500 (Thymosin β4)", cat:"Healing & Recovery", route:"SC/IM", unit:"mg",
    protocols:[
      { goal:"Injury Recovery (Loading)", dose_per_kg:null, flat_dose:10, freq:"Twice weekly", duration:"4–6 weeks loading", notes:"Loading phase. Then drop to 5mg/week maintenance." },
      { goal:"Maintenance", dose_per_kg:null, flat_dose:5, freq:"Once weekly", duration:"Ongoing", notes:"After loading phase complete." },
    ]},
  { id:"cjc_ipa", name:"CJC-1295 (No DAC)", cat:"Growth Hormone Axis", route:"SC", unit:"mcg",
    protocols:[
      { goal:"Anti-Aging / Body Recomp", dose_per_kg:null, flat_dose:100, freq:"3× daily (always paired with Ipamorelin)", duration:"12–24 weeks", notes:"Inject before bed and around training. Always stack with Ipamorelin." },
    ]},
  { id:"ipamorelin", name:"Ipamorelin", cat:"Growth Hormone Axis", route:"SC", unit:"mcg",
    protocols:[
      { goal:"Anti-Aging / Body Recomp", dose_per_kg:null, flat_dose:200, freq:"3× daily (pair with CJC-1295)", duration:"12–24 weeks", notes:"Inject fasted ideally. Before bed injection most important." },
      { goal:"Sleep & GH Pulse", dose_per_kg:null, flat_dose:300, freq:"Once daily before bed", duration:"Ongoing", notes:"Single bedtime dose amplifies natural GH pulse." },
    ]},
  { id:"sermorelin", name:"Sermorelin", cat:"Growth Hormone Axis", route:"SC", unit:"mcg",
    protocols:[
      { goal:"Anti-Aging / Sleep", dose_per_kg:null, flat_dose:200, freq:"Once daily before bed", duration:"3–6 months", notes:"Gentlest GH peptide. Preserves pituitary feedback loop." },
    ]},
  { id:"ghk_cu", name:"GHK-Cu", cat:"Skin & Healing", route:"SC / Topical", unit:"mg",
    protocols:[
      { goal:"Skin Rejuvenation", dose_per_kg:null, flat_dose:1, freq:"Once daily SC or twice daily topical", duration:"8–12 weeks", notes:"SC injection achieves systemic collagen effects. Topical for local skin." },
      { goal:"Hair Loss", dose_per_kg:null, flat_dose:1, freq:"SC every other day", duration:"12+ weeks", notes:"Stack with AHK-Cu for enhanced hair follicle stimulation." },
    ]},
  // WEIGHT & METABOLIC
  { id:"sema", name:"Semaglutide", cat:"Weight & Metabolic", route:"SC (weekly)", unit:"mg",
    protocols:[
      { goal:"Weight Loss", dose_per_kg:null, flat_dose:0.25, freq:"Once weekly SC", duration:"4 weeks then titrate up", notes:"Start 0.25mg/week. Titrate: 0.25→0.5→1.0→1.7→2.4mg over 16 weeks." },
    ]},
  { id:"tirze", name:"Tirzepatide", cat:"Weight & Metabolic", route:"SC (weekly)", unit:"mg",
    protocols:[
      { goal:"Weight Loss", dose_per_kg:null, flat_dose:2.5, freq:"Once weekly SC", duration:"4 weeks then titrate", notes:"Start 2.5mg/week. Titrate every 4 weeks: 2.5→5→7.5→10→12.5→15mg." },
    ]},
  { id:"aod9604", name:"AOD-9604", cat:"Weight & Metabolic", route:"SC", unit:"mcg",
    protocols:[
      { goal:"Fat Loss", dose_per_kg:null, flat_dose:300, freq:"Once daily fasted AM", duration:"12–16 weeks", notes:"Take fasted for maximum lipolytic effect. Stack with Fragment 176-191." },
    ]},
  { id:"fragment", name:"HGH Fragment 176-191", cat:"Weight & Metabolic", route:"SC", unit:"mcg",
    protocols:[
      { goal:"Fat Loss", dose_per_kg:null, flat_dose:250, freq:"Twice daily fasted", duration:"8–12 weeks", notes:"Fasted AM and pre-workout. Most effective for stubborn fat." },
    ]},
  // COGNITIVE
  { id:"semax", name:"Semax", cat:"Cognitive & Nootropic", route:"Intranasal", unit:"mcg",
    protocols:[
      { goal:"Cognitive Enhancement", dose_per_kg:null, flat_dose:600, freq:"Once daily intranasal", duration:"2–4 weeks on, 2 weeks off", notes:"Apply 200mcg per nostril. 3 drops 100mcg/drop solution." },
    ]},
  { id:"selank", name:"Selank", cat:"Cognitive & Nootropic", route:"Intranasal", unit:"mcg",
    protocols:[
      { goal:"Anxiety / Focus", dose_per_kg:null, flat_dose:750, freq:"Once daily intranasal", duration:"2–4 weeks on, 2 weeks off", notes:"Stack with Semax for balanced focus + calm. XS20 blend covers both." },
    ]},
  // ANTI-AGING
  { id:"epithalon", name:"Epithalon", cat:"Anti-Aging & Longevity", route:"SC/IV", unit:"mg",
    protocols:[
      { goal:"Longevity Protocol", dose_per_kg:null, flat_dose:10, freq:"Once daily for 10 days", duration:"10-day cycle, repeat 1–2× per year", notes:"Khavinson protocol: 10mg/day for 10 consecutive days. Can repeat in 6 months." },
    ]},
  { id:"nad", name:"NAD+", cat:"Anti-Aging / Energy", route:"IV/SC", unit:"mg",
    protocols:[
      { goal:"Energy & Anti-Aging", dose_per_kg:null, flat_dose:500, freq:"IV infusion over 2–4 hours", duration:"3–5 consecutive days loading, then monthly", notes:"Slow IV drip to minimise flush/nausea. Start at 250mg first session." },
      { goal:"Maintenance SC", dose_per_kg:null, flat_dose:100, freq:"SC injection 2–3× per week", duration:"Ongoing", notes:"SC route for maintenance between IV sessions." },
    ]},
  // SLEEP
  { id:"dsip", name:"DSIP", cat:"Sleep & Recovery", route:"SC/IV", unit:"mcg",
    protocols:[
      { goal:"Sleep Reset", dose_per_kg:null, flat_dose:200, freq:"Once before bed for 5–7 nights", duration:"1 week cycle", notes:"Resets circadian rhythm. Most effective for shift workers and jet lag." },
    ]},
  { id:"melatonin_inj", name:"Melatonin (Injectable)", cat:"Sleep & Recovery", route:"SC", unit:"mg",
    protocols:[
      { goal:"Sleep Onset", dose_per_kg:null, flat_dose:1, freq:"SC 30min before bed", duration:"As needed", notes:"0.5–1mg SC. Far more potent than oral at same dose due to 100% bioavailability." },
    ]},
  // SEXUAL HEALTH
  { id:"pt141", name:"PT-141 (Bremelanotide)", cat:"Sexual Health", route:"SC", unit:"mg",
    protocols:[
      { goal:"Sexual Function", dose_per_kg:null, flat_dose:1, freq:"SC 45min before activity", duration:"As needed", notes:"Start at 0.5mg to assess tolerance. Max 2mg per dose. Not more than once per 72h." },
    ]},
  // HORMONES
  { id:"hcg", name:"HCG", cat:"Hormones & Fertility", route:"SC/IM", unit:"IU",
    protocols:[
      { goal:"TRT Support (HPTA)", dose_per_kg:null, flat_dose:500, freq:"2× per week SC", duration:"Throughout TRT cycle", notes:"500 IU 2× weekly maintains testicular function and size during TRT." },
      { goal:"PCT", dose_per_kg:null, flat_dose:2000, freq:"Every other day for 3 weeks", duration:"3 weeks (start of PCT)", notes:"2000 IU EOD for first 3 weeks of PCT alongside Clomid/Nolvadex." },
    ]},
  // ANDROGENS (for reference/education)
  { id:"test_e", name:"Testosterone Enanthate", cat:"Androgens & Steroids", route:"IM/SC (oil)", unit:"mg",
    protocols:[
      { goal:"TRT (Replacement)", dose_per_kg:null, flat_dose:125, freq:"Twice weekly IM or SC", duration:"Ongoing", notes:"TRT range: 100–200mg/week. 125mg 2× weekly = 250mg/week total. Monitor bloods." },
      { goal:"Performance", dose_per_kg:null, flat_dose:250, freq:"Twice weekly IM", duration:"12–16 week cycle", notes:"250mg 2× weekly = 500mg/week. Run AI (Anastrozole 0.5mg EOD). PCT required." },
    ]},
  { id:"test_c", name:"Testosterone Cypionate", cat:"Androgens & Steroids", route:"IM/SC (oil)", unit:"mg",
    protocols:[
      { goal:"TRT (Replacement)", dose_per_kg:null, flat_dose:100, freq:"Twice weekly", duration:"Ongoing", notes:"Similar to Enanthate. Longer half-life — once-weekly dosing also used in TRT." },
      { goal:"Performance", dose_per_kg:null, flat_dose:250, freq:"Twice weekly IM", duration:"12–16 week cycle", notes:"500mg/week. Standard beginner testosterone cycle. AI and PCT required." },
    ]},
  { id:"nand_dec", name:"Nandrolone Decanoate (Deca)", cat:"Androgens & Steroids", route:"IM (oil)", unit:"mg",
    protocols:[
      { goal:"Joint Support / Lean Mass", dose_per_kg:null, flat_dose:200, freq:"Once weekly IM", duration:"12–16 weeks", notes:"Always run with testosterone. 200–400mg/week. Run Cabergoline for prolactin." },
    ]},
  // SARMS
  { id:"lgd4033", name:"LGD-4033 (Ligandrol)", cat:"SARMs", route:"Oral", unit:"mg",
    protocols:[
      { goal:"Lean Muscle", dose_per_kg:null, flat_dose:10, freq:"Once daily oral", duration:"8–12 weeks", notes:"5–10mg/day. Start at 5mg. PCT recommended after. Suppresses natural testosterone." },
    ]},
  { id:"mk677", name:"MK-677 (Ibutamoren)", cat:"SARMs", route:"Oral", unit:"mg",
    protocols:[
      { goal:"GH / IGF-1 Elevation", dose_per_kg:null, flat_dose:25, freq:"Once daily before bed", duration:"3–6 months minimum", notes:"10–25mg/day. Before bed to align with natural GH pulse. Increases hunger." },
    ]},
  { id:"rad140", name:"RAD-140 (Testolone)", cat:"SARMs", route:"Oral", unit:"mg",
    protocols:[
      { goal:"Lean Muscle / Strength", dose_per_kg:null, flat_dose:10, freq:"Once daily oral", duration:"8–10 weeks", notes:"10–20mg/day. Potent — start low. Strong HPTA suppression. PCT required." },
    ]},
  { id:"ostarine", name:"Ostarine (MK-2866)", cat:"SARMs", route:"Oral", unit:"mg",
    protocols:[
      { goal:"Lean Muscle / Joint Health", dose_per_kg:null, flat_dose:25, freq:"Once daily oral", duration:"8–12 weeks", notes:"15–25mg/day. Mildest SARM. Minimal suppression at lower doses." },
    ]},
  { id:"cardarine", name:"GW-501516 (Cardarine)", cat:"SARMs", route:"Oral", unit:"mg",
    protocols:[
      { goal:"Endurance / Fat Loss", dose_per_kg:null, flat_dose:10, freq:"Once daily oral", duration:"8 weeks max", notes:"10–20mg/day. Not a true SARM — PPARδ agonist. Endurance + fat burning." },
    ]},
];

// ── VIAL SIZES FOR RECONSTITUTION ─────────────────────────────────────────
const COMMON_VIALS = [
  { label:"1mg", mg:1 }, { label:"2mg", mg:2 }, { label:"5mg", mg:5 },
  { label:"10mg", mg:10 }, { label:"100mcg (0.1mg)", mg:0.1 },
  { label:"250mcg (0.25mg)", mg:0.25 }, { label:"500mcg (0.5mg)", mg:0.5 },
  { label:"200IU", iu:200 }, { label:"500IU", iu:500 }, { label:"1000IU", iu:1000 },
  { label:"2000IU", iu:2000 }, { label:"5000IU", iu:5000 }, { label:"10000IU", iu:10000 },
];
const BAC_WATER = [1, 2, 3, 5, 10];
const SYRINGE_SIZES = [
  { label:"1mL / U-100 insulin (100 units = 1mL)", units_per_ml:100 },
  { label:"0.5mL / U-100 insulin (50 units = 0.5mL)", units_per_ml:100 },
  { label:"1mL standard (1 unit = 0.01mL)", units_per_ml:100 },
];

const CATS = ["All", ...new Set(COMPOUNDS.map(c => c.cat))];

export default function DosageCalculator() {
  const [tab, setTab] = useState("dosage");
  // Dosage Calculator state
  const [weight, setWeight] = useState("");
  const [weightUnit, setWeightUnit] = useState("kg");
  const [selectedCompound, setSelectedCompound] = useState(null);
  const [selectedProtocol, setSelectedProtocol] = useState(null);
  const [catFilter, setCatFilter] = useState("All");
  const [search, setSearch] = useState("");
  const [result, setResult] = useState(null);
  // Reconstitution state
  const [vialAmt, setVialAmt] = useState("");
  const [vialUnit, setVialUnit] = useState("mg");
  const [bacWater, setBacWater] = useState(2);
  const [desiredDose, setDesiredDose] = useState("");
  const [desiredUnit, setDesiredUnit] = useState("mcg");

  const weightKg = useMemo(() => {
    const w = parseFloat(weight);
    if (isNaN(w)) return null;
    return weightUnit === "lbs" ? w * 0.453592 : w;
  }, [weight, weightUnit]);

  const filteredCompounds = useMemo(() => {
    return COMPOUNDS.filter(c => {
      const matchCat = catFilter === "All" || c.cat === catFilter;
      const matchSearch = !search.trim() || c.name.toLowerCase().includes(search.toLowerCase());
      return matchCat && matchSearch;
    });
  }, [catFilter, search]);

  const calculate = () => {
    if (!selectedCompound || !selectedProtocol) return;
    const proto = selectedCompound.protocols[selectedProtocol];
    const dose = proto.flat_dose;
    const unit = selectedCompound.unit;
    setResult({ dose, unit, proto, compound: selectedCompound });
  };

  // Reconstitution calc
  const reconCalc = useMemo(() => {
    const vial = parseFloat(vialAmt);
    const dose = parseFloat(desiredDose);
    if (isNaN(vial) || isNaN(dose) || !bacWater) return null;
    // Convert everything to mcg
    const vialMcg = vialUnit === "mg" ? vial * 1000 : vialUnit === "IU" ? vial : vial;
    const doseMcg = desiredUnit === "mg" ? dose * 1000 : desiredUnit === "IU" ? dose : dose;
    // mcg per mL
    const concPerMl = vialMcg / bacWater;
    // mL per dose
    const mlPerDose = doseMcg / concPerMl;
    // Units on U-100 syringe
    const unitsOnSyringe = mlPerDose * 100;
    // Number of doses in vial
    const dosesPerVial = vialMcg / doseMcg;
    return {
      concPerMl: concPerMl.toFixed(2),
      mlPerDose: mlPerDose.toFixed(3),
      unitsOnSyringe: unitsOnSyringe.toFixed(1),
      dosesPerVial: dosesPerVial.toFixed(1),
      vialMcg,
      doseMcg,
    };
  }, [vialAmt, vialUnit, bacWater, desiredDose, desiredUnit]);

  const catColors = {
    "Healing & Recovery": "#22c55e",
    "Growth Hormone Axis": "#3b82f6",
    "Weight & Metabolic": "#ef4444",
    "Cognitive & Nootropic": "#a855f7",
    "Anti-Aging & Longevity": "#f59e0b",
    "Sexual Health": "#f97316",
    "Hormones & Fertility": "#14b8a6",
    "Sleep & Recovery": "#818cf8",
    "Androgens & Steroids": "#dc2626",
    "SARMs": "#8b5cf6",
    "Skin & Healing": "#ec4899",
    "Anti-Aging / Energy": "#f59e0b",
  };

  return (
    <div style={{
      minHeight:"100vh", background:"#060608",
      fontFamily:"'Courier New', monospace", color:"#e2e8f0",
    }}>
      {/* HEADER */}
      <div style={{
        background:"linear-gradient(180deg,#0d0000 0%,#130404 60%,#0a0a0a 100%)",
        borderBottom:"3px solid #dc2626",
        position:"relative",
        overflow:"hidden",
      }}>
        {/* Main brand row */}
        <div style={{ display:"flex", alignItems:"stretch", maxWidth:900, margin:"0 auto", padding:"0 20px" }}>

          {/* CENTER — Title block */}
          <div style={{ flex:1, padding:"14px 20px", display:"flex", flexDirection:"column", justifyContent:"center" }}>
            <div style={{ fontSize:9, color:"#dc2626", letterSpacing:"0.2em", marginBottom:4, textTransform:"uppercase" }}>
              Spawn Nutra Presents
            </div>
            <div style={{
              fontFamily:"'Impact','Arial Black',sans-serif",
              fontSize:26, fontWeight:900, letterSpacing:"0.08em", lineHeight:1,
              color:"#f5c800", textShadow:"2px 2px 0 #7f1d1d",
            }}>MAD SCIENTIST 5150</div>
            <div style={{ fontSize:9, color:"#94a3b8", letterSpacing:"0.18em", marginTop:5 }}>
              DOSAGE · RECONSTITUTION · PROTOCOL CALCULATOR
            </div>
            </div>

          </div>

        {/* Tabs */}
        <div style={{ display:"flex", gap:0, borderTop:"1px solid #1a1a1a" }}>
          {[
            { id:"dosage", label:"💉 DOSAGE CALCULATOR" },
            { id:"reconstitution", label:"🧪 RECONSTITUTION" },
            { id:"reference", label:"📋 QUICK REFERENCE" },
          ].map(t => (
            <button key={t.id} onClick={() => setTab(t.id)} style={{
              flex:1, padding:"12px 8px",
              background: tab === t.id ? "#dc2626" : "transparent",
              border:"none", borderBottom: tab === t.id ? "3px solid #f5c800" : "3px solid transparent",
              color: tab === t.id ? "#fff" : "#6b7280",
              cursor:"pointer", fontSize:11, letterSpacing:"0.12em",
              fontFamily:"'Impact','Arial Black',sans-serif",
              transition:"all 0.15s",
            }}>{t.label}</button>
          ))}
        </div>
      </div>

      <div style={{ maxWidth:900, margin:"0 auto", padding:"24px 20px" }}>

        {/* ── DOSAGE CALCULATOR TAB ─────────────────────────────── */}
        {tab === "dosage" && (
          <div>
            <div style={{ marginBottom:24, padding:"16px 20px", background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.25)", borderRadius:8 }}>
              <div style={{ fontSize:10, color:"#dc2626", letterSpacing:"0.15em", marginBottom:10 }}>⚠ RESEARCH USE ONLY · NOT MEDICAL ADVICE</div>
              <div style={{ fontSize:12, color:"#6b7280" }}>Protocols are based on commonly referenced research doses. Always consult a healthcare professional before use.</div>
            </div>

            {/* Weight input */}
            <div style={{ marginBottom:24 }}>
              <div style={{ fontSize:10, color:"#f5c800", letterSpacing:"0.15em", marginBottom:8 }}>STEP 1 — YOUR BODY WEIGHT</div>
              <div style={{ display:"flex", gap:10, alignItems:"center" }}>
                <input
                  type="number" value={weight} onChange={e => setWeight(e.target.value)}
                  placeholder="Enter weight..."
                  style={{ flex:1, minWidth:0, padding:"12px 16px", background:"#0f0f0f", border:"1px solid #2a2a2a", borderRadius:6, color:"#e2e8f0", fontSize:18, fontFamily:"inherit", outline:"none" }}
                />
                {["kg","lbs"].map(u => (
                  <button key={u} onClick={() => setWeightUnit(u)} style={{
                    padding:"12px 14px", border:"2px solid", flexShrink:0,
                    borderColor: weightUnit === u ? "#dc2626" : "#2a2a2a",
                    background: weightUnit === u ? "rgba(220,38,38,0.15)" : "transparent",
                    color: weightUnit === u ? "#dc2626" : "#6b7280",
                    borderRadius:6, cursor:"pointer", fontSize:14, fontFamily:"inherit",
                  }}>{u}</button>
                ))}
              </div>
              {weightKg && <div style={{ marginTop:6, fontSize:11, color:"#475569" }}>= {weightKg.toFixed(1)} kg / {(weightKg * 2.20462).toFixed(1)} lbs</div>}
            </div>

            {/* Compound selector */}
            <div style={{ marginBottom:24 }}>
              <div style={{ fontSize:10, color:"#f5c800", letterSpacing:"0.15em", marginBottom:8 }}>STEP 2 — SELECT COMPOUND</div>
              <div style={{ display:"flex", gap:10, marginBottom:12, flexWrap:"wrap" }}>
                <input
                  value={search} onChange={e => setSearch(e.target.value)}
                  placeholder="Search compounds..."
                  style={{ flex:1, minWidth:160, padding:"8px 12px", background:"#0f0f0f", border:"1px solid #2a2a2a", borderRadius:6, color:"#e2e8f0", fontSize:12, fontFamily:"inherit", outline:"none" }}
                />
                <select value={catFilter} onChange={e => setCatFilter(e.target.value)} style={{
                  padding:"8px 12px", background:"#0f0f0f", border:"1px solid #2a2a2a", borderRadius:6, color:"#94a3b8", fontSize:11, fontFamily:"inherit", cursor:"pointer",
                }}>
                  {CATS.map(c => <option key={c}>{c}</option>)}
                </select>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(200px,1fr))", gap:8 }}>
                {filteredCompounds.map(c => (
                  <button key={c.id} onClick={() => { setSelectedCompound(c); setSelectedProtocol(null); setResult(null); }} style={{
                    padding:"10px 14px", textAlign:"left",
                    background: selectedCompound?.id === c.id ? "rgba(220,38,38,0.15)" : "#0f0f0f",
                    border:"2px solid",
                    borderColor: selectedCompound?.id === c.id ? "#dc2626" : "#1a1a1a",
                    borderLeft:`4px solid ${catColors[c.cat] || "#475569"}`,
                    borderRadius:6, cursor:"pointer", transition:"all 0.15s",
                    color:"#e2e8f0", fontFamily:"inherit",
                  }}>
                    <div style={{ fontSize:12, fontWeight:700 }}>{c.name}</div>
                    <div style={{ fontSize:9, color:catColors[c.cat] || "#475569", marginTop:2, letterSpacing:"0.06em" }}>{c.cat}</div>
                    <div style={{ fontSize:9, color:"#475569", marginTop:2 }}>Route: {c.route}</div>
                  </button>
                ))}
              </div>
            </div>

            {/* Protocol selector */}
            {selectedCompound && (
              <div style={{ marginBottom:24 }}>
                <div style={{ fontSize:10, color:"#f5c800", letterSpacing:"0.15em", marginBottom:8 }}>STEP 3 — SELECT GOAL / PROTOCOL</div>
                <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                  {selectedCompound.protocols.map((p, i) => (
                    <button key={i} onClick={() => { setSelectedProtocol(i); setResult(null); }} style={{
                      padding:"12px 16px", textAlign:"left",
                      background: selectedProtocol === i ? "rgba(245,200,0,0.08)" : "#0f0f0f",
                      border:"2px solid",
                      borderColor: selectedProtocol === i ? "#f5c800" : "#1a1a1a",
                      borderRadius:6, cursor:"pointer", color:"#e2e8f0", fontFamily:"inherit",
                    }}>
                      <div style={{ fontSize:13, fontWeight:700, color: selectedProtocol === i ? "#f5c800" : "#e2e8f0" }}>🎯 {p.goal}</div>
                      <div style={{ fontSize:11, color:"#6b7280", marginTop:4 }}>
                        Dose: {p.flat_dose}{selectedCompound.unit} · {p.freq} · {p.duration}
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Calculate button */}
            {selectedCompound && selectedProtocol !== null && (
              <button onClick={calculate} style={{
                width:"100%", padding:"16px",
                background:"linear-gradient(135deg,#dc2626,#991b1b)",
                border:"2px solid #f5c800", borderRadius:8,
                color:"#f5c800", fontSize:16, letterSpacing:"0.15em",
                fontFamily:"'Impact','Arial Black',sans-serif",
                cursor:"pointer", marginBottom:24,
                boxShadow:"0 0 20px rgba(220,38,38,0.4)",
                transition:"all 0.2s",
              }}>⚡ CALCULATE PROTOCOL</button>
            )}

            {/* Result */}
            {result && (
              <div style={{
                padding:24, background:"#0a0f1a",
                border:"2px solid #22d3ee",
                borderRadius:10,
                boxShadow:"0 0 30px rgba(34,211,238,0.15)",
              }}>
                <div style={{ fontSize:10, color:"#22d3ee", letterSpacing:"0.15em", marginBottom:16 }}>📊 PROTOCOL RESULT — {result.compound.name.toUpperCase()}</div>
                
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(160px,1fr))", gap:12, marginBottom:20 }}>
                  {[
                    { label:"DOSE PER INJECTION", val:`${result.dose}${result.unit}`, color:"#22d3ee" },
                    { label:"FREQUENCY", val:result.proto.freq, color:"#f5c800" },
                    { label:"ROUTE", val:result.compound.route, color:"#22c55e" },
                    { label:"DURATION", val:result.proto.duration, color:"#a855f7" },
                  ].map(item => (
                    <div key={item.label} style={{ padding:"12px 14px", background:"#060608", border:`1px solid ${item.color}30`, borderTop:`3px solid ${item.color}`, borderRadius:6 }}>
                      <div style={{ fontSize:8, color:item.color, letterSpacing:"0.12em", marginBottom:4 }}>{item.label}</div>
                      <div style={{ fontSize:15, fontWeight:700, color:"#f1f5f9", lineHeight:1.3 }}>{item.val}</div>
                    </div>
                  ))}
                </div>

                {result.proto.notes && (
                  <div style={{ padding:"12px 16px", background:"rgba(245,200,0,0.06)", border:"1px solid rgba(245,200,0,0.2)", borderRadius:6 }}>
                    <div style={{ fontSize:9, color:"#f5c800", letterSpacing:"0.12em", marginBottom:4 }}>💡 PROTOCOL NOTES</div>
                    <div style={{ fontSize:13, color:"#94a3b8", lineHeight:1.7 }}>{result.proto.notes}</div>
                  </div>
                )}

                <div style={{ marginTop:16, padding:"10px 14px", background:"rgba(220,38,38,0.06)", border:"1px solid rgba(220,38,38,0.2)", borderRadius:6, fontSize:11, color:"#6b7280" }}>
                  ⚠ Research use only. Protocols sourced from peer-reviewed literature and clinical reference ranges. Not a substitute for medical advice.
                </div>
              </div>
            )}
          </div>
        )}

        {/* ── RECONSTITUTION TAB ────────────────────────────────── */}
        {tab === "reconstitution" && (
          <div>
            <div style={{ marginBottom:24, padding:"14px 18px", background:"rgba(34,211,238,0.05)", border:"1px solid rgba(34,211,238,0.2)", borderRadius:8 }}>
              <div style={{ fontSize:11, color:"#22d3ee", letterSpacing:"0.1em", marginBottom:6 }}>🧪 PEPTIDE RECONSTITUTION CALCULATOR</div>
              <div style={{ fontSize:12, color:"#6b7280" }}>Enter your vial size, BAC water volume, and desired dose — get exact injection volume and units on your syringe.</div>
            </div>

            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:20, marginBottom:24 }}>
              {/* Vial */}
              <div style={{ padding:20, background:"#0f0f0f", border:"1px solid #1a1a1a", borderRadius:8 }}>
                <div style={{ fontSize:10, color:"#f5c800", letterSpacing:"0.15em", marginBottom:12 }}>STEP 1 — VIAL AMOUNT</div>
                <input
                  type="number" value={vialAmt} onChange={e => setVialAmt(e.target.value)}
                  placeholder="e.g. 5"
                  style={{ width:"100%", padding:"10px 14px", background:"#060608", border:"1px solid #2a2a2a", borderRadius:6, color:"#e2e8f0", fontSize:16, fontFamily:"inherit", outline:"none", boxSizing:"border-box" }}
                />
                <div style={{ display:"flex", gap:6, marginTop:10 }}>
                  {["mg","mcg","IU"].map(u => (
                    <button key={u} onClick={() => setVialUnit(u)} style={{
                      flex:1, padding:"7px 0",
                      background: vialUnit === u ? "rgba(245,200,0,0.15)" : "transparent",
                      border:"1px solid", borderColor: vialUnit === u ? "#f5c800" : "#2a2a2a",
                      color: vialUnit === u ? "#f5c800" : "#475569",
                      borderRadius:5, cursor:"pointer", fontSize:11, fontFamily:"inherit",
                    }}>{u}</button>
                  ))}
                </div>
                {/* Quick presets */}
                <div style={{ fontSize:9, color:"#374151", marginTop:10, marginBottom:6, letterSpacing:"0.08em" }}>QUICK PRESETS</div>
                <div style={{ display:"flex", flexWrap:"wrap", gap:4 }}>
                  {COMMON_VIALS.map(v => (
                    <button key={v.label} onClick={() => {
                      if (v.mg) { setVialAmt(String(v.mg)); setVialUnit("mg"); }
                      else { setVialAmt(String(v.iu)); setVialUnit("IU"); }
                    }} style={{
                      padding:"3px 7px", background:"#1a1a1a", border:"1px solid #2a2a2a",
                      borderRadius:4, color:"#6b7280", fontSize:9, cursor:"pointer", fontFamily:"inherit",
                    }}>{v.label}</button>
                  ))}
                </div>
              </div>

              {/* BAC Water */}
              <div style={{ padding:20, background:"#0f0f0f", border:"1px solid #1a1a1a", borderRadius:8 }}>
                <div style={{ fontSize:10, color:"#f5c800", letterSpacing:"0.15em", marginBottom:12 }}>STEP 2 — BAC WATER (mL)</div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(5,1fr)", gap:6 }}>
                  {BAC_WATER.map(v => (
                    <button key={v} onClick={() => setBacWater(v)} style={{
                      padding:"14px 6px", textAlign:"center",
                      background: bacWater === v ? "rgba(34,211,238,0.15)" : "#060608",
                      border:"2px solid", borderColor: bacWater === v ? "#22d3ee" : "#1a1a1a",
                      borderRadius:6, color: bacWater === v ? "#22d3ee" : "#6b7280",
                      cursor:"pointer", fontSize:14, fontWeight:700, fontFamily:"inherit",
                    }}>{v}<br/><span style={{ fontSize:8 }}>mL</span></button>
                  ))}
                </div>
              </div>
            </div>

            {/* Desired dose */}
            <div style={{ padding:20, background:"#0f0f0f", border:"1px solid #1a1a1a", borderRadius:8, marginBottom:24 }}>
              <div style={{ fontSize:10, color:"#f5c800", letterSpacing:"0.15em", marginBottom:12 }}>STEP 3 — DESIRED DOSE PER INJECTION</div>
              <div style={{ display:"flex", gap:10, alignItems:"center" }}>
                <input
                  type="number" value={desiredDose} onChange={e => setDesiredDose(e.target.value)}
                  placeholder="e.g. 250"
                  style={{ flex:1, padding:"12px 16px", background:"#060608", border:"1px solid #2a2a2a", borderRadius:6, color:"#e2e8f0", fontSize:18, fontFamily:"inherit", outline:"none" }}
                />
                {["mcg","mg","IU"].map(u => (
                  <button key={u} onClick={() => setDesiredUnit(u)} style={{
                    padding:"12px 16px",
                    background: desiredUnit === u ? "rgba(34,211,238,0.15)" : "transparent",
                    border:"2px solid", borderColor: desiredUnit === u ? "#22d3ee" : "#2a2a2a",
                    color: desiredUnit === u ? "#22d3ee" : "#475569",
                    borderRadius:6, cursor:"pointer", fontSize:13, fontFamily:"inherit",
                  }}>{u}</button>
                ))}
              </div>
            </div>

            {/* Reconstitution Result */}
            {reconCalc && (
              <div style={{ padding:24, background:"#0a0f1a", border:"2px solid #22d3ee", borderRadius:10, boxShadow:"0 0 30px rgba(34,211,238,0.15)" }}>
                <div style={{ fontSize:10, color:"#22d3ee", letterSpacing:"0.15em", marginBottom:16 }}>🔬 RECONSTITUTION RESULTS</div>
                
                <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:12, marginBottom:20 }}>
                  {[
                    { label:"CONCENTRATION", val:`${reconCalc.concPerMl} ${vialUnit}/mL`, sub:"after adding BAC water", color:"#22d3ee" },
                    { label:"VOLUME PER DOSE", val:`${reconCalc.mlPerDose} mL`, sub:`per ${desiredDose}${desiredUnit} dose`, color:"#f5c800" },
                    { label:"INSULIN SYRINGE UNITS", val:`${reconCalc.unitsOnSyringe} units`, sub:"on U-100 insulin syringe", color:"#22c55e" },
                    { label:"DOSES PER VIAL", val:reconCalc.dosesPerVial, sub:"total injections available", color:"#a855f7" },
                  ].map(item => (
                    <div key={item.label} style={{ padding:"16px 18px", background:"#060608", border:`1px solid ${item.color}30`, borderTop:`3px solid ${item.color}`, borderRadius:6 }}>
                      <div style={{ fontSize:8, color:item.color, letterSpacing:"0.12em", marginBottom:6 }}>{item.label}</div>
                      <div style={{ fontSize:22, fontWeight:900, fontFamily:"'Impact','Arial Black',sans-serif", color:"#f1f5f9", letterSpacing:"0.04em" }}>{item.val}</div>
                      <div style={{ fontSize:10, color:"#475569", marginTop:4 }}>{item.sub}</div>
                    </div>
                  ))}
                </div>

                {/* Visual syringe guide */}
                <div style={{ padding:"14px 18px", background:"rgba(34,211,238,0.04)", border:"1px solid rgba(34,211,238,0.15)", borderRadius:8 }}>
                  <div style={{ fontSize:9, color:"#22d3ee", letterSpacing:"0.12em", marginBottom:8 }}>💉 SYRINGE GUIDE (U-100 INSULIN SYRINGE)</div>
                  <div style={{ fontSize:13, color:"#94a3b8", lineHeight:1.8 }}>
                    Draw up to the <strong style={{ color:"#22d3ee" }}>{reconCalc.unitsOnSyringe} unit mark</strong> on your U-100 insulin syringe.<br/>
                    This equals exactly <strong style={{ color:"#f5c800" }}>{reconCalc.mlPerDose} mL</strong> which contains your target dose of <strong style={{ color:"#22c55e" }}>{desiredDose}{desiredUnit}</strong>.
                  </div>
                  {/* Scale bar */}
                  <div style={{ marginTop:12, position:"relative", height:32, background:"#1a1a1a", borderRadius:4, overflow:"hidden" }}>
                    <div style={{
                      position:"absolute", left:0, top:0, height:"100%",
                      width:`${Math.min((parseFloat(reconCalc.unitsOnSyringe)/100)*100, 100)}%`,
                      background:"linear-gradient(90deg,#22d3ee,#3b82f6)",
                      borderRadius:4, transition:"width 0.5s ease",
                      display:"flex", alignItems:"center", justifyContent:"flex-end", paddingRight:8,
                    }}>
                      <span style={{ fontSize:10, color:"#fff", fontWeight:700 }}>{reconCalc.unitsOnSyringe}u</span>
                    </div>
                    {/* tick marks */}
                    {[0,10,20,30,40,50,60,70,80,90,100].map(t => (
                      <div key={t} style={{ position:"absolute", left:`${t}%`, top:0, height:"100%", borderLeft:"1px solid rgba(255,255,255,0.1)" }}>
                        <span style={{ position:"absolute", bottom:2, left:2, fontSize:7, color:"#374151" }}>{t}</span>
                      </div>
                    ))}
                  </div>
                  <div style={{ fontSize:9, color:"#374151", marginTop:4, textAlign:"right" }}>100 units = 1.0 mL</div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* ── QUICK REFERENCE TAB ───────────────────────────────── */}
        {tab === "reference" && (
          <div>
            <div style={{ fontSize:10, color:"#f5c800", letterSpacing:"0.15em", marginBottom:16 }}>📋 PEPTIDE QUICK REFERENCE GUIDE</div>
            {[
              { title:"BAC WATER RECONSTITUTION RULE OF THUMB", items:[
                "2mg vial + 2mL BAC water = 1mg/mL (1000mcg/mL)",
                "5mg vial + 2mL BAC water = 2.5mg/mL (2500mcg/mL)",
                "10mg vial + 2mL BAC water = 5mg/mL (5000mcg/mL)",
                "For every 100 units on U-100 syringe = 1.0 mL",
              ]},
              { title:"COMMON CONVERSIONS", items:[
                "1mg = 1,000mcg",
                "0.5mg = 500mcg",
                "0.25mg = 250mcg",
                "0.1mg = 100mcg",
                "10 units on U-100 syringe = 0.1mL",
                "50 units on U-100 syringe = 0.5mL",
              ]},
              { title:"INJECTION SITE GUIDE", items:[
                "SC (subcutaneous): Pinch skin on abdomen, inject at 45°",
                "IM (intramuscular): Glute, quad, or delt — 90° angle",
                "Intranasal: Tilt head back slightly, 1–2 drops per nostril",
                "Rotate injection sites to prevent lipoatrophy",
              ]},
              { title:"STORAGE RULES", items:[
                "Lyophilised (freeze-dried) peptides: Fridge or freezer, away from light",
                "After reconstitution: Refrigerate 2–8°C, use within 3–4 weeks",
                "GLP-1 pens (Semaglutide/Tirzepatide): Fridge until first use, then room temp up to 28 days",
                
                "Never freeze reconstituted peptides — BAC water does not freeze well",
                "Keep away from direct light — UV degrades peptides rapidly",
              ]},
              { title:"COMMON BEGINNER MISTAKES", items:[
                "Drawing too much BAC water — dilutes concentration, wastes product",
                "Not rotating injection sites — causes lumps and lipoatrophy",
                "Injecting too fast — slow steady pressure for SC injections",
                "Not allowing skin to dry after alcohol swab — stings more",
                "Skipping PCT after suppressive SARMs or AAS — risks prolonged suppression",
              ]},
            ].map(section => (
              <div key={section.title} style={{ padding:"16px 20px", background:"#0f0f0f", border:"1px solid #1a1a1a", borderRadius:8, marginBottom:14 }}>
                <div style={{ fontSize:10, color:"#f5c800", letterSpacing:"0.15em", marginBottom:10 }}>{section.title}</div>
                {section.items.map((item, i) => (
                  <div key={i} style={{ display:"flex", gap:8, marginBottom:6, fontSize:12, color:"#94a3b8", lineHeight:1.6 }}>
                    <span style={{ color:"#dc2626", flexShrink:0 }}>▸</span>
                    {item}
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}

      </div>

      <div style={{ padding:"16px 20px", borderTop:"1px solid #1a1a1a", textAlign:"center", fontSize:10, color:"#374151", letterSpacing:"0.08em" }}>
        MAD SCIENTIST 5150 · SPAWN NUTRA · RESEARCH USE ONLY · NOT MEDICAL ADVICE
      </div>

      <style>{`
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { width: 5px; }
        ::-webkit-scrollbar-track { background: #060608; }
        ::-webkit-scrollbar-thumb { background: #1a1a1a; border-radius: 3px; }
        select option { background: #0f0f0f; }
        input[type=number]::-webkit-inner-spin-button { opacity: 0.5; }
      `}</style>
    </div>
  );
}
